import z from "zod";
import { USCheckboxFilterSchema } from "./base-schema";
import { USCheckboxValueOptionsSchema } from "./us-checkbox-options";

const PropertyTypeKeys = ["NON-VACANT LAND", "VACANT LAND"] as const;

const PropertyTypeOptionValuesSchema = USCheckboxValueOptionsSchema(PropertyTypeKeys);

export const USPropertyTypeSchema = USCheckboxFilterSchema.extend({
  id: z.literal("property-type-id"),
  values: z.array(PropertyTypeOptionValuesSchema),
});
